import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--left",
  "use": "icon-slider--left-usage",
  "viewBox": "0 0 10 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 16\" id=\"icon-slider--left\"><path d=\"M8.823 14.258a.751.751 0 0 1-1.06 1.061L1.398 8.955a1.25 1.25 0 0 1 0-1.768l6.011-6.01a.75.75 0 0 1 1.06 1.06L3.167 7.541a.75.75 0 0 0 0 1.06l5.657 5.657Z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\".5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol